/* eslint-disable react/jsx-closing-bracket-location */
import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';

import Forgive from '../LoanList/Forgive';
import ForgiveAndReduce from '../LoanList/ForgiveAndReduce';
import SkipPayment from '../LoanList/SkipPayment';

import Button from '@material-ui/core/Button';
import { withTranslation } from 'react-i18next';
import LoanService from '../../Service/LoanService';
import BaseGrid from './UpdateLoanGrids/BaseGrid';
import HeaderGrid from './UpdateLoanGrids/GridForHeader';

const API_URLS = window.AppConfig.API_URLS;
const APP_IMAGES = window.AppConfig.APP_IMAGES;

class UpdateLoan extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_open: '',
			_isLoading: false
		};
	}

	startLoader = () => {
		this.setState({
			_isLoading: true
		});
	};

	stopLoader = () => {
		this.setState({
			_isLoading: false
		});
	};

	skipPaymentAndExtend = () => {
		this.setState({
			_open: 'SKIP&EXTEND'
		});
	};

	skipPaymentAndADD = () => {
		this.setState({
			_open: 'SKIP&ADD'
		});
	};

	forgiveAndReduce = () => {
		this.setState({
			_open: 'FORGIVE&REDUCE'
		});
	};

	forgiveLoan = () => {
		this.setState({
			_open: 'FORGIVE'
		});
	};

	onBack = () => {
		this.setState({
			_open: ''
		});
	};

	isAnyDueInstallmentExceptLast = () => {
		if (this.props.loanObject.installments.length === 0) return false;

		const installments = this.props.loanObject.installments;
		const dueInstallments = installments.filter(
			(installment, index) => installment.state === 'DUE' && index !== installments.length - 1
		);
		return dueInstallments.length > 0;
	};

	genrateButton = (name, action) => {
		return (
			<Grid className="no-shadow" container id="reduce-width" justify="center" spacing={2}>
				<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
					<Button
						aria-label="add"
						className="back-btn-large-review btn-green"
						fullWidth
						onClick={action}
						// style={{ backgroundColor: 'darkblue', color: 'white' }}
						type="submit"
						variant="extended">
						{this.props.t(name)}
					</Button>
				</Grid>
			</Grid>
		);
	};

	getBtnUpdate = () => {
		const buttons = [];
		if (this.props.loanObject.frequency !== 'LUMP_SUM') {
			if (this.isAnyDueInstallmentExceptLast()) {
				buttons.push(this.genrateButton('buttons.skip_payment_and_add', this.skipPaymentAndADD));
			}
			buttons.push(this.genrateButton('buttons.skip_payment_and_extend', this.skipPaymentAndExtend));

			buttons.push(this.genrateButton('buttons.forgive_payment_and_reduce_loan_amount', this.forgiveAndReduce));
		}
		buttons.push(this.genrateButton('buttons.forgive_balance_of_loan', this.forgiveLoan));
		return buttons;
	};

	paymentAction = async (action, toastSuccess, toastFail, id = '') => {
		try {
			this.startLoader();
			const requestBody = {
				action,
				id: +id
			};
			const response = await LoanService.create(
				`${API_URLS.LOAN}/${this.props.loanObject.id}/payment-action`,
				requestBody
			);
			if (response.status) {
				toastSuccess();
				this.stopLoader();
				this.props.closeUpdateFlow();
			} else {
				toastFail();
				this.stopLoader();
			}
			await this.props.refreshState();
		} catch (err) {
			this.stopLoader();
			toastFail();
		}
	};

	render() {
		const { t } = this.props;
		if (this.state._open === 'SKIP&ADD' || this.state._open === 'SKIP&EXTEND') {
			return (
				<SkipPayment
					type={this.state._open}
					isLoading={this.state._isLoading}
					loanObject={this.props.loanObject}
					onBack={this.onBack}
					onBackToDetails={this.props.closeUpdateFlow}
					paymentAction={this.paymentAction}
				/>
			);
		} else if (this.state._open === 'FORGIVE&REDUCE') {
			return (
				<ForgiveAndReduce
					isLoading={this.state._isLoading}
					loanObject={this.props.loanObject}
					onBack={this.onBack}
					onBackToDetails={this.props.closeUpdateFlow}
					paymentAction={this.paymentAction}
				/>
			);
		} else if (this.state._open === 'FORGIVE') {
			return (
				<Forgive
					isLoading={this.state._isLoading}
					loanObject={this.props.loanObject}
					onBack={this.onBack}
					onBackToDetails={this.props.closeUpdateFlow}
					paymentAction={this.paymentAction}
				/>
			);
		} else {
			return (
				<section>
					<BaseGrid>
						<HeaderGrid>
							<img
								alt="Invite"
								className="img-reponsive"
								src={APP_IMAGES.UPDATE}
								style={{ maxWidth: '100%', maxHeight: 'initial' }}
							/>
							<h4 className="text-center">{t('label.would_you_like_to')}</h4>
						</HeaderGrid>
						{this.getBtnUpdate()}
						<Grid className="no-shadow" container id="reduce-width" justify="center" spacing={2}>
							<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
								<Button
									aria-label="add"
									className="back-btn-large-review"
									fullWidth
									id="forgive-back"
									onClick={this.props.closeUpdateFlow}
									// style={{ backgroundColor: 'darkblue', color: 'white' }}
									type="submit"
									variant="extended">
									{t('buttons.back')}
								</Button>
							</Grid>
						</Grid>
					</BaseGrid>
				</section>
			);
		}
	}
}

export default withTranslation()(UpdateLoan);
